import * as ACTIONS from '../actions';
import { DEFAULT_METRICS_MODAL_STATE } from '../constants';

const metricsReducer = (state = { currentMetrics: null, currentSummary: {} }, action) => {
  switch (action.type) {
    case ACTIONS.LOAD_LEADS.SUCCESS:
      return {
        ...state,
        currentMetrics: action.payload.data.metaInfo && action.payload.data.metaInfo.metrics || null,
        currentSummary: {
          ...state.currentSummary,
          ...(action.payload.data.metaInfo && action.payload.data.metaInfo.summary || {})
        }
      };

    case ACTIONS.SAVE_METRICS.SUCCESS:
      return {
        ...state,
        currentMetrics: action.payload
      };

    case ACTIONS.FETCHQTDD.SUCCESS:
      return {
        ...state,
        currentMetrics: action.payload.data.metrics,
        currentSummary: {
          ...state.currentSummary,
          ...action.payload.data.summary
        }
      };

    default:
      return state;
  }
};

export default metricsReducer;
